module.exports = __webpack_public_path__ + "static/media/florin_apetrei.9c9623c8.png";